import React, { Component } from "react";
import { Link } from "react-router-dom";
//import simplWS_client from "./wsService";
import { toast } from "react-toastify";
import {
  getSystemLatestData,
  ws_getSystemLatestData,
  getSystemIntervalData,
  getSystemInfo,
  getSystemBasics,
  getSystemIDfromHandle,
  getSystem,
  setSystemSignals,
  initSystemUpdate,
  ws_get,
  ws_post,
} from "../services/systemService";

import { setJwt, deleteHeaders } from "../services/httpService";
import { getUser } from "../services/userService";
import "./dashboard.css";
import "../index.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ProgressBar from "react-bootstrap/ProgressBar";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Modal from "react-bootstrap/Modal";
import BackGroundRectangle from "../components/backgroundRect";

import TstatSettingsModal from "./TstatSettingsModal";
import { isNullOrUndefined } from "joi-browser";

//const simplWS_client = new WebSocket("ws://127.0.0.1:8082");

class ThermoStatLocalClient extends Component {
  constructor(props) {
    super(props);
  }
  state = {
    systemControlsLocalLength: 0,
    setOffLine: 0,
    newNodeName: "unknown",
  };

  async componentDidMount() {
    const handleID =
      this.props.systemHandleID; /*this.props.match.params.systemHandleID*/
    console.log("System Handle ID: ", handleID);

    const systemIDRaw = await getSystemIDfromHandle(handleID);
    console.log("SystemID Raw:", systemIDRaw);
    const systemID = systemIDRaw.data.data.system_id;

    const systemName = (await getSystem(systemID)).data.data[0].systemID.name;
    console.log("System Name: ", systemName);
    const tempORInitiated = false;
    //const systemID = localStorage.getItem("systemID");
    this.setState({
      handleID,
      systemID,
      systemName,
      tempORInitiated,
    });
    this.timerID = setInterval(() => this.tick(/*ipAddress*/), 1000);
  }

  componentWillUnmount() {
    clearInterval(this.timerID);
  }

  async getSystemDataOnline() {
    const response_temp = await getSystemLatestData(
      this.props.systemHandleID
      /*this.props.match.params.systemHandleID*/
    );
    const response = response_temp.data.data[0];

    console.log("Build Data Response: ", response);
    let applianceData = [];
    if (response) {
      applianceData = response.data.deviceLedger.Appliances;
      let thermostats = [];
      if (applianceData)
        thermostats = applianceData.filter(
          (thermostat) => thermostat.loadType === "HVAC w SimplTherm"
        );
      console.log("Appliances", applianceData);
      console.log("Thermostats", thermostats);

      let thermostatsLength = 0;
      if (!thermostats) {
        thermostats = {};
        thermostatsLength = 0;
      } else {
        thermostatsLength = thermostats.length;
        console.log("Thermostats Length: ", thermostatsLength);
        console.log("Thermostats: ", thermostats);
        console.log("Selected Node Name: ", this.state.newNodeName);
        if (this.state.newNodeName !== "unknown") {
          for (let i = 0; i < thermostatsLength; i++) {
            if (
              thermostats[i].nodeName === this.state.newNodeName &&
              thermostats[i].orCount > 10 &&
              this.state.tempORInitiated
            ) {
              console.log("Thermostat Node Name: ", thermostats[i].nodeName);
              console.log(
                ".............Found the right SimplThermostat: orCount",
                thermostats[i].orCount
              );
              await setSystemSignals(
                this.state.systemID,
                "81",
                "TBD",
                "0",
                this.state.newNodeName,
                (thermostats[i].tSet / 100).toString()
              );
              await initSystemUpdate(
                this.props
                  .systemHandleID /*this.props.match.params.systemHandleID*/
              );
              this.setState({ tempORInitiated: false });
            }
          }
        }
      }
      this.setState({ thermostats, thermostatsLength });
    }
  }
  tick(/*ipAddress*/) {
    this.setState({
      dateNow: new Date(),
    });
    /*const setOffLine = this.state.setOffLine;
    if (setOffLine === 1) this.getSystemDataOffline(ipAddress);
    else */ this.getSystemDataOnline();
  }
  sleep(milliseconds) {
    const date = Date.now();
    let currentDate = null;
    do {
      currentDate = Date.now();
    } while (currentDate - date < milliseconds);
  }

  cancelOverRide = async (nodeName) => {
    console.log(
      "************************  Cancel Override. Node Name: ",
      nodeName
    );
    const thisSystemID = (
      await getSystemIDfromHandle(
        this.props.systemHandleID /*this.props.match.params.systemHandleID*/
      )
    ).data.data.system_id;
    console.log("This System ID: ", thisSystemID);
    toast.warning("Canceling Override...wait...");
    await setSystemSignals(
      this.state.systemID,
      "81",
      "TBD",
      "0",
      nodeName,
      "40"
    );

    await initSystemUpdate(
      this.props.systemHandleID /*this.props.match.params.systemHandleID*/
    );

    //this.sleep(10000);
    toast.success("Override was canceled...");
  };

  changeThermostatSetting = async (tSet, durationTime, nodeName) => {
    console.log("Selected Node Name in changeThermostatSetting: ", nodeName);
    this.setState({ newNodeName: nodeName });
    const ipAddress = this.state.ipAddress;
    const setOffLine = this.state.setOffLine;
    if (setOffLine === 1) {
      let postMessage = "";
      postMessage = JSON.stringify({
        nodename: String(nodeName),
        ThermostatTSet: tSet,
      });
      ///8888888888888  ToDo: Add durationTime to the offline mode
      let rcvd_data = await ws_post(ipAddress, postMessage);
      console.log("Received data from ESP32 Server:", rcvd_data);
    } else {
      let durationTimeInt = parseInt(durationTime);
      if (durationTimeInt < 5) durationTimeInt = 5;
      const durationTimeStr = durationTimeInt.toString();
      toast.warning("Sending settings to the system...wait...");
      await setSystemSignals(
        this.state.systemID,
        "81",
        "TBD",
        durationTimeStr,
        nodeName,
        tSet
      );

      await initSystemUpdate(
        this.props.systemHandleID /*this.props.match.params.systemHandleID*/
      );
      this.setState({ tempORInitiated: true });
      /*this.sleep(10000);
      await setSystemSignals(
        this.state.systemID,
        "81",
        "TBD",
        "0",
        nodeName,
        tSet
      );

      await initSystemUpdate(this.props.match.params.systemHandleID);
      this.sleep(15000);*/
      toast.success("Settings were updated...");
    }
  };
  handleOffLine = (e) => {
    console.log("In OffLine Selection");
    let setOffLine = this.state.setOffLine;
    if (setOffLine === 0) setOffLine = 1;
    else setOffLine = 0;
    this.setState({ setOffLine });
  };
  render() {
    //console.log("ThermostatLength in render: ", this.state.thermostatsLength);
    return (
      <div
        style={{
          width: "350px",
          position: "absolute",
          left: "50%",
          transform: "translateX(-50%)",
          marginTop: "20px",
          marginBottom: "150px",
          zIndex: 1,
        }}
      >
        {/* <p
          className="basicParagraph"
          style={{ width: "100%", textAlign: "center", fontSize: "12px" }}
        >
          {this.state.systemName} Thermostats
        </p>*/}
        {this.state.thermostatsLength !== 0 && (
          <>
            <div style={{width: "100%", display: "flex", justifyContent: "center"}}>
              <div style={{
                height: "200px",
                width: "320px", // Match or exceed table width
                overflowY: "auto",
                overflowX: "hidden", // Hide horizontal scroll
                // display:"flex",
                // justifyContent: "center",
                // border: "1px solid black", // Optional for visual clarity
              }}>
                <table
                  className="table"
                  style={{
                    marginTop: "10px",
                    // width: "320px",
                    // border: "1px solid blue"
                    //transform: "translateX(20px)",
                  }}
                >
                  <thead style={{position: "sticky", top: "0", padding: "0", margin: "0", background: "white"}}>
                    <tr style={{padding: "0", margin: "0"}}>
                      <th
                        style={{
                          width: "80px",
                          margin: "0px",
                          padding: "0px",
                          fontsize: "10px",
                          height: "25px",
                          verticalAlign: "middle",
                        }}
                      >
                        Node Name
                      </th>
                      <th
                        style={{
                          width: "80px",
                          margin: "0px",
                          padding: "0px",
                          fontsize: "10px",
                          height: "25px",
                          verticalAlign: "middle",
                        }}
                      >
                        SNS. T
                      </th>
                      <th
                        style={{
                          width: "80px",
                          margin: "0px",
                          padding: "0px",
                          fontsize: "10px",
                          height: "25px",
                          verticalAlign: "middle",
                        }}
                      >
                        Room Temp.
                      </th>
                      <th
                        style={{
                          width: "80px",
                          margin: "0px",
                          padding: "0px",
                          fontsize: "10px",
                          height: "25px",
                          verticalAlign: "middle",
                        }}
                      >
                        Settings
                      </th>
                    </tr>
                  </thead>

                  
                  {this.state.thermostats &&
                    this.state.thermostatsLength > 0 &&
                    this.state.thermostats.map((thermostat) => (
                      <tr
                        key={thermostat.id}
                        style={{ height: "5px", margin: "0px", padding: "0px" }}
                      >
                        <td
                          style={{
                            margin: "0px",
                            padding: "0px",
                            width: "90px",
                            height: "10px",
                            verticalAlign: "middle",
                          }}
                        >
                          {thermostat.nodeName}
                        </td>
                        {thermostat.extTemp !== 15000 && (
                          <td
                            style={{
                              margin: "0px",
                              padding: "0px",
                              width: "90px",
                              height: "10px",
                              verticalAlign: "middle",
                            }}
                          >
                            {((thermostat.extTemp / 100.0) * 1.8 + 32).toFixed(1)}
                            &#176;F
                          </td>
                        )}
                        {thermostat.extTemp === 15000 && (
                          <td
                            style={{
                              // width: "40px",
                              // textAlign: "center",
                              // margin: "0px",
                              // padding: "0px",
                              // position: "relative",
                              // left: "0px",
                              // height: "10px",

                              margin: "0px",
                              padding: "0px",
                              width: "90px",
                              height: "10px",
                              verticalAlign: "middle",
                            }}
                          >
                            --
                          </td>
                        )}

                        {thermostat.extTemp !== 15000 && (
                          <td
                            style={{
                              // width: "40px",
                              // textAlign: "center",
                              // margin: "0px",
                              // padding: "0px",
                              // position: "relative",
                              // left: "0px",
                              // height: "10px",

                              margin: "0px",
                              padding: "0px",
                              width: "90px",
                              height: "10px",
                              verticalAlign: "middle",
                            }}
                          >
                            --
                          </td>
                        )}
                        {thermostat.extTemp === 15000 &&
                          thermostat.extSensor !== 1 && (
                            <td
                              style={{
                                // width: "40px",
                                // textAlign: "center",
                                // color: "blue",
                                // position: "relative",
                                // left: "0px",
                                // height: "10px",
                                // margin: "0px",
                                // padding: "0px",

                                margin: "0px",
                                padding: "0px",
                                width: "90px",
                                height: "10px",
                                verticalAlign: "middle",
                                color: "blue"
                              }}
                            >
                              {(thermostat.roomTemp / 100.0).toFixed(1)} &#176;F
                            </td>
                          )}
                        {thermostat.extTemp === 15000 &&
                          thermostat.extSensor === 1 && (
                            <td
                              style={{
                                // width: "40px",
                                // textAlign: "center",
                                // color: "magenta",
                                // position: "relative",
                                // left: "0px",
                                // height: "15px",
                                // margin: "0px",
                                // padding: "0px",

                                margin: "0px",
                                padding: "0px",
                                width: "90px",
                                height: "10px",
                                verticalAlign: "middle",
                                color: "magenta"
                              }}
                            >
                              {(thermostat.roomTemp / 100.0).toFixed(1)} &#176;F
                            </td>
                          )}

                        {/********************************************************************************** */}
                        <td
                          style={{
                            margin: "0px",
                            padding: "0px",
                            height: "25px",
                            verticalAlign: "middle",
                          }}
                        >
                          <TstatSettingsModal
                            nodeName={thermostat.nodeName}
                            tSet={thermostat.tSet}
                            tSetHeat={thermostat.tSetHeat}
                            tSetCool={thermostat.tSetCool}
                            rhSet={thermostat.rhSet}
                            orCount={thermostat.orCount}
                            simplThermCool={thermostat.relaySetting & 0x0001}
                            simplThermHeat={(thermostat.relaySetting & 0x0002) >> 1}
                            changeThermostatSetting={this.changeThermostatSetting}
                            cancelOverRide={this.cancelOverRide}
                          />
                        </td>
                      </tr>
                    ))}
                  {/* <tr>
                    test
                  </tr>
                  <tr>
                    test
                  </tr>
                  <tr>
                    test
                  </tr>
                  <tr>
                    test
                  </tr>
                  <tr>
                    test
                  </tr>
                  <tr>
                    test
                  </tr>
                  <tr>
                    test
                  </tr>
                  <tr>
                    test
                  </tr>
                  <tr>
                    test
                  </tr>
                  <tr>
                    test
                  </tr>
                  <tr>
                    test
                  </tr>
                  <tr>
                    test
                  </tr> */}
                  
                </table>
              </div>
            </div>
          </>
        )}
        {this.state.thermostatsLength === 0 && (
          <p
            className="basicParagraph"
            style={{ width: "100%", textAlign: "center", fontSize: "12px" }}
          >
            No Thermostats in the system.
          </p>
        )}
      </div>
    );
  }
}
export default ThermoStatLocalClient;
